'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.links = exports.LinksService = void 0;
var LinksService = /** @class */ (function () {
    function LinksService() {
        var _this = this;
        this.listeners = new Set();
        this.handleLinkClick = function (event) {
            var target = _this.getTarget(event);
            if (event.defaultPrevented) {
                // link is handled elsewhere (e.g. router)
                return;
            }
            if (target && target.getAttribute('data-ignore')) {
                return;
            }
            if (target && target.tagName === 'A' && !_this.isExternal(target)) {
                event.preventDefault();
                _this.listeners.forEach(function (listener) {
                    try {
                        listener(target.getAttribute('href'));
                    }
                    catch (e) {
                        console.group();
                        console.error('Error in link handler for', target);
                        console.error(e);
                        console.groupEnd();
                    }
                });
            }
        };
    }
    /**
     * Registers an event handler to be executed every time the user clicks
     * on an anchor element whose href is an internal link.
     * @returns A function that unregisters the event handler when called.
     */
    LinksService.prototype.registerLinkHandler = function (handler) {
        var _this = this;
        this.attachClickEvent();
        this.listeners.add(handler);
        return function () {
            _this.listeners.delete(handler);
            if (_this.listeners.size === 0) {
                _this.deregisterLinkHandler();
            }
        };
    };
    /**
     * Get event target or target link element from composed path if available
     */
    LinksService.prototype.getTarget = function (event) {
        if (!event.composedPath) {
            return event.target;
        }
        else {
            return event
                .composedPath()
                .find(function (el) { return el.tagName === 'A'; });
        }
    };
    LinksService.prototype.attachClickEvent = function () {
        if (this.listeners.size > 0) {
            return;
        }
        document.body.addEventListener('click', this.handleLinkClick);
    };
    LinksService.prototype.deregisterLinkHandler = function () {
        document.body.removeEventListener('click', this.handleLinkClick);
    };
    LinksService.prototype.isExternal = function (link) {
        var href = link.getAttribute('href');
        return (!href ||
            /nofollow|noopener/.test(link.getAttribute('rel')) ||
            /blank/.test(link.getAttribute('target')) ||
            /^(https?:|mailto:)/.test(href));
    };
    return LinksService;
}());
exports.LinksService = LinksService;
exports.links = new LinksService();
